import Tooltip from '@mui/material/Tooltip'
import {
  MdKeyboardDoubleArrowLeft,
  MdKeyboardDoubleArrowRight,
} from 'react-icons/md'
import PremiumLocked from '../../../../Items/Lock'
import Button from '../../../../Button'

const FooterBeforeResponse = ({
  isSubject,
  answer,
  isLoading,
  handleSubmit,
  hasSubscription,
  currentGrila,
  handleUpdateGrid,
  currentGridIndex,
  handleNextGrid,
  handlePrevGrid,
  subjectLength,
  numberOfAnsweredGrids,
  userChoice,
  isSubmittingSubject,
  isSubmittingGrid,
  showProgress,
  explanation,
}) => {
  return (
    <div className="relative bottom-0 flex items-center z-[100] !bg-container-background border-t border-brd-primary justify-center h-[65px] w-full p-[5px] rounded-bl rounded-br">
      {isSubject ? (
        <div className="absolute left-4">
          <Tooltip title="Înapoi">
            <span className="flex items-center justify-center">
              <Button
                className="bg-btn-primary h-8 w-8 !p-0 !rounded-full "
                disabled={
                  isLoading || isSubject
                    ? currentGridIndex === 0
                    : !hasSubscription
                }
                onClick={handlePrevGrid}
              >
                <MdKeyboardDoubleArrowLeft className="w-[25px] h-[25px] mr-[2px]" />
              </Button>
            </span>
          </Tooltip>
        </div>
      ) : null}

      {isSubject && showProgress ? (
        !isLoading ? (
          numberOfAnsweredGrids !== subjectLength ? (
            <progress
              data-label={`${numberOfAnsweredGrids} / ${subjectLength}`}
              className="h-full  w-[50%]"
              value={numberOfAnsweredGrids}
              max={subjectLength}
            ></progress>
          ) : answer ? (
            <></>
          ) : (
            <Button
              isLoading={isSubmittingSubject}
              onClick={handleSubmit}
              id="send-subject-answer-button"
              className="bg-btn-primary  w-[50%] h-[2.7rem]"
            >
              Trimite
            </Button>
          )
        ) : (
          <button
            type="button"
            className="rounded-[8px] border-none bg-[#82828233] cursor-pointer  w-[50%] h-[2.7rem] text-white text-[15px] font-bold"
            disabled
          ></button>
        )
      ) : null}

      {/* Grid page  */}
      {!isSubject && !answer ? (
        <Button
          id="send-answer-button"
          isLoading={isSubmittingGrid}
          className="max-w-[250px] h-[2.7rem] submit-grid w-[calc(50%-6px)] bg-btn-primary"
          disabled={
            userChoice === undefined || userChoice === null || isNaN(userChoice)
          }
          onClick={() => {
            !answer ? handleSubmit() : handleUpdateGrid()
          }}
        >
          Trimite răspunsul
        </Button>
      ) : null}

      {answer === null || (isSubject && answer) ? (
        <div className="absolute right-4">
          <Tooltip title={!isSubject ? 'Skip' : 'Următoarea Grilă'}>
            <span className="flex skip-grid items-center justify-center">
              <Button
                isLoading={!isSubject ? isLoading : ''}
                className="bg-btn-primary h-8 w-8 text-[20px] !p-0 !rounded-full "
                disabled={
                  isLoading ||
                  (isSubject && currentGridIndex === subjectLength - 1)
                }
                id="next-grid-button"
                onClick={
                  !isSubject ? () => handleUpdateGrid(true) : handleNextGrid
                }
                isLocked={!hasSubscription && currentGrila && !isSubject}
                isLockedMessage="Ai nevoie de un abonament pentru a putea sări peste o grilă"
              >
                <MdKeyboardDoubleArrowRight className="w-[25px] h-[25px] ml-[2px]" />
              </Button>
            </span>
          </Tooltip>
        </div>
      ) : null}
    </div>
  )
}

export default FooterBeforeResponse
